module.exports = require('./helpers/bundle-url').getBundleURL('01RMl') + "a.a12ee820.png";